import '../snippets/product-gallery.js';
import '../components/back-in-stock.js';
import '../snippets/completeLook.js';
import 'sticky-sidebar/dist/jquery.sticky-sidebar.js';


$(document).on('ready', function(){
    $('#shopify-section-template_product').on('variantChange', function(e){
        if(e.variant) {
            $('[data-variant-sku]').html(e.variant.sku);
        }
    });

    const links = document.querySelectorAll(".pdp_icon-down a");

    for (const link of links) {
    link.addEventListener("click", clickHandler);
    }

    function clickHandler(e) {
    e.preventDefault();
    const href = this.getAttribute("href");
    

    document.querySelector(href).scrollIntoView({
        behavior: "smooth",
        block: 'start' 
    });
    }


});


import Cookies from 'js-cookie'

$(document).ready(function() {

  function openDrawer() {
    $('html').addClass('js-drawer-open-description');
    $('body').addClass('js-drawer-open-description');
    $('#DescriptionDrawer').addClass('js-drawer-open');
  }

  function closeDrawer() {
    $('html').removeClass('js-drawer-open-description');
    $('body').removeClass('js-drawer-open-description');
    $('#DescriptionDrawer').removeClass('js-drawer-open');
  }

  ////////////////// Menu cookie
  $(document).on('click', '.remove_tag a, .js-drawer-close, .filter-button-wrapper, #blur-backdrop', function() {
    Cookies.set('open_desc_drawer', false);
    closeDrawer();
  });

  $(document).on('click', ' .js-drawer-open-button-description', function() {
    Cookies.set('open_desc_drawer', true);
    openDrawer()
  });

  var cookie_filter_drawer = Cookies.get('open_filter_description');

  if(typeof cookie_filter_drawer != 'undefined' && cookie_filter_drawer != 'false') {
    openDrawer();
  } else {
    closeDrawer();
  }


  function openDrawerPage() {
    $('html').addClass('js-drawer-open-page');
    $('body').addClass('js-drawer-open-page');
    $('#PageDrawer').addClass('js-drawer-open');
  }

  function closeDrawerPage() {
    $('html').removeClass('js-drawer-open-page');
    $('body').removeClass('js-drawer-open-page');
    $('#PageDrawer').removeClass('js-drawer-open');
  }

  ////////////////// Menu cookie
  $(document).on('click', '.remove_tag a, .js-drawer-close, .filter-button-wrapper, #blur-backdrop', function() {
    Cookies.set('open_page_drawer', false);
    closeDrawerPage();
  });

  $(document).on('click', ' .js-drawer-open-button-page', function() {
    Cookies.set('open_page_drawer', true);
    openDrawerPage()
  });

  var cookie_filter_drawer = Cookies.get('open_filter_description');

  if(typeof cookie_filter_drawer != 'undefined' && cookie_filter_drawer != 'false') {
    openDrawerPage();
  } else {
    closeDrawerPage();
  }

});



$(document).on('click', '.product-single__link[data-page]', function() {
      
        $("#PageDrawer.drawer--page").addClass('is-loading');
        setTimeout(function(){
          $("#PageDrawer.drawer--page").removeClass('is-loading');
        }, 1500);
        $("#pageContainer.drawer__page")
        .load(this.dataset.page + "#PageContainer .main-content .row", function () {
        });

        $("#PageDrawer .drawer__header .drawer__title")
        .load(this.dataset.page + "#PageContainer .main-content .section-header h1", function () {
        }).data();        
    });

$(document).on('click', '.product-single__link[data-page]', function() {
    Cookies.set('open_page_drawer', true);
  });


  $(document).ready(function() {

    if ( $('.item__controls-wrapper').length ) {
        theme.shoppingControls.init();
    }

});
if ($(window).width() > 960) {
  var stickySidebar = new StickySidebar('#sidebar', {
    topSpacing: 100,
    bottomSpacing: -200,
    innerWrapperSelector: '.sidebar__inner',
    stickyClass: 'is-affixed',
    containerSelector: '.product-single__media--wrapper'
  });
};